import { useEffect, useState } from "react";
import { Card, Progress } from "flowbite-react";
import { FaServer } from "react-icons/fa";
import { getTamanhoUploads } from "../../../api/user";

const Uso = () => {
  const [uso, setUso] = useState({
    porcentagem: 0,
    tamanhoMb: 0,
    limiteMb: 200,
    ilimitado: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchUsoServidor() {
      try {
        const { tamanho, limiteArmazenamentoMb } = await getTamanhoUploads();
        const tamanhoEmMB = parseFloat(tamanho);
        const limiteMb =
          Number.isFinite(Number(limiteArmazenamentoMb)) &&
          Number(limiteArmazenamentoMb) > 0
            ? Number(limiteArmazenamentoMb)
            : 200;
        const ilimitado = limiteArmazenamentoMb === null;
        const porcentagem = ilimitado
          ? 0
          : Math.min((tamanhoEmMB / limiteMb) * 100, 100);

        setUso({
          porcentagem,
          tamanhoMb: Number.isFinite(tamanhoEmMB) ? tamanhoEmMB : 0,
          limiteMb,
          ilimitado,
        });
      } catch (error) {
        console.error("Erro ao obter uso do servidor:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchUsoServidor();
  }, []);

  return (
    <div className="mt-8">
      <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mt-8 lg:mt-2 mb-4 select-none cursor-default">
        Uso do Servidor
      </h2>

      <Card className="shadow-md text-center rounded-xl bg-white border border-gray-300 w-full p-4">
        <FaServer className="text-4xl text-gray-500 mx-auto mb-2" />
        <h3 className="text-lg font-semibold text-gray-800">
          Espaço Utilizado:
        </h3>
        <p className="text-gray-600">
          {loading
            ? "Carregando..."
            : uso.ilimitado
            ? `${uso.tamanhoMb.toFixed(2)} MB utilizados`
            : `${uso.tamanhoMb.toFixed(2)} MB de ${uso.limiteMb} MB`}
        </p>
        <Progress progress={uso.porcentagem} color="red" className="my-2" />
        {!loading && !uso.ilimitado ? (
          <p className="text-sm text-gray-500">{uso.porcentagem.toFixed(2)}%</p>
        ) : null}
      </Card>
    </div>
  );
};

export default Uso;
